import { trim, isType } from "@utils"

const doc = window.document

function get (key) {
  return localStorage.getItem(key)
}

function all () {
  let cookies = doc.cookie.split(/; ?/g),
    data = {}
  for (let i = cookies.length - 1; i >= 0; i--) {
    if (!trim(cookies[i])) {
      continue
    }
    let kvp = cookies[i].split("=")
    let key = unescape(kvp[0])
    data[key] = unescape(kvp[1])
  }
  return data
}

function set (key, data, time) {
  if (!key) {
    return
  }
  return localStorage.setItem(key, data)
}

function formatDate (date) {
  var dates = new Date(date)
  var YY = dates.getFullYear() + "-"
  var MM =
    (dates.getMonth() + 1 < 10
      ? "0" + (dates.getMonth() + 1)
      : dates.getMonth() + 1) + "-"
  var DD = dates.getDate() < 10 ? "0" + dates.getDate() : dates.getDate()
  var hh =
    (dates.getHours() < 10 ? "0" + dates.getHours() : dates.getHours()) + ":"
  var mm =
    (dates.getMinutes() < 10 ? "0" + dates.getMinutes() : dates.getMinutes()) +
    ":"
  var ss =
    dates.getSeconds() < 10 ? "0" + dates.getSeconds() : dates.getSeconds()
  return YY + MM + DD + " " + hh + mm + ss
}

function remove (key) {
  if (!key || !_has(key)) {
    return
  }
  localStorage.removeItem(key)
  //doc.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

function clearAll () {
  Object.keys(all()).forEach(function (key) {
    remove(key)
  })
}

function _has (key) {
  return localStorage.key(key)
}

Storage.prototype.setExpire = (key, value, expire) => {
  let obj = {
    data: value,
    time: Date.now(),
    expire: expire
  }
  //localStorage 设置的值不能为对象,转为json字符串
  localStorage.setItem(key, JSON.stringify(obj))
}

Storage.prototype.getExpire = key => {
  let val = localStorage.getItem(key)
  if (!val) {
    return val
  }
  val = JSON.parse(val)
  if (Date.now() - val.time > val.expire) {
    localStorage.removeItem(key)
    return null
  }
  return val.data
}

export default {
  get,
  all,
  set,
  remove,
  clearAll,
  has: _has
}
